import { render, staticRenderFns } from "./card-secondary.vue?vue&type=template&id=49d83268&scoped=true&"
import script from "./card-secondary.vue?vue&type=script&lang=js&"
export * from "./card-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d83268",
  null
  
)

export default component.exports